import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mine_rate_fail",
  "use": "icon-mine_rate_fail-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-mine_rate_fail\"><g fill=\"none\" fill-rule=\"evenodd\" opacity=\".25\"><path d=\"M0 0h28v28H0z\" /><path d=\"M14 25.667C7.556 25.667 2.333 20.443 2.333 14 2.333 7.556 7.556 2.333 14 2.333S25.667 7.556 25.667 14 20.443 25.667 14 25.667Zm0-13.317-3.3-3.3-1.65 1.65 3.3 3.3-3.3 3.3 1.65 1.65 3.3-3.3 3.3 3.3 1.65-1.65-3.3-3.3 3.3-3.3-1.65-1.65-3.3 3.3Z\" fill=\"#E84C3D\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol